import { Container } from '@/components/layout';
import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding-bottom: 50px;
  }

  &:not(:first-child) {
    margin-top: 50px;
  }
`;

export const OrganizationsAndEmployeesList = ({ lists, isMobile }) => {
  return (
    <Box width="100%">
      <Container
        style={{
          paddingRight: '16px',
          paddingTop: isMobile ? '80px' : '100px',
          paddingBottom: isMobile ? '80px' : '100px',
        }}
      >
        {lists.map((list, index) => (
          <Wrapper
            key={list.title}
            display={isMobile ? 'block' : 'flex'}
            alignItems="center"
            flexDirection={index % 2 === 0 ? 'row-reverse' : 'row'}
          >
            <Box
              width={isMobile ? '100%' : '60%'}
              sx={{
                mr: index % 2 === 0 ? '0' : '60px',
                ml: index % 2 === 0 && !isMobile ? '60px' : '0',
              }}
            >
              <Box sx={{ fontSize: '38px', color: '#525255', pb: '20px' }}>
                {list.title}
              </Box>
              <Box sx={{ fontSize: '18px', color: '#303032' }}>
                {list.description}
              </Box>
            </Box>
            <Box width={isMobile ? '100%' : '40%'}>
              <img src={list.img} alt="" />
            </Box>
          </Wrapper>
        ))}
      </Container>
    </Box>
  );
};
